"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXCLUDED_BILLS_UNDO_COPY = void 0;
exports.billsFoundLine = billsFoundLine;
/**
 * Financial Analysis §2's count line, and what it says once every detected bill
 * has been excluded (BEN-141 FP-035).
 *
 * Removing a detected bill deactivates it (it stays in Recurring as "Excluded",
 * where it can be turned back on). Once all of them were excluded, §2 said "We
 * found 0 recurring payments": six were found, and the user excluded them. The
 * screen could not tell "none detected" from "you excluded all of them", and
 * offered no way back.
 *
 * `excluded` is the client's own count: inactive, non-income streams with a Plaid
 * `stream_id` (detected bills), from `GET /forecasting/recurring/?include_inactive=true`.
 * The analysis response does not carry it.
 */
function billsFoundLine(found, excluded) {
    if (found === 0 && excluded > 0) {
        return excluded === 1
            ? "You've excluded the 1 detected bill."
            : `You've excluded all ${excluded} detected bills.`;
    }
    return found === 1
        ? "We found 1 recurring payment"
        : `We found ${found} recurring payments`;
}
/** Beside the excluded-all line: where the bills went, and how to get one back. */
exports.EXCLUDED_BILLS_UNDO_COPY = "Turn any back on in Recurring.";
//# sourceMappingURL=billsFoundCopy.js.map